import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionZeppSyncPayload,
	IActionZeppSyncPayloadDone,
	IActionZeppSyncPayloadError,
} from './types';

export const zeppSync = actionCreatorAsync<
	IActionZeppSyncPayload,
	IActionZeppSyncPayloadDone,
	IActionZeppSyncPayloadError
>(
	'zeppSync',
	async (params) => {
		const { time } = params;
		const { data } = await Api.zepp.sync({
			body: { time },
		});

		return data;
	},
);
